/**
 * Route path constants
 * Centralized route definitions for easy maintenance and refactoring
 */
export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_DETAILS: '/organizations/:id',
  DEVICES: '/devices',
  USERS: '/users',
  USER_DETAILS: '/users/:id',
  TOKEN_USAGE: '/token-usage',
  TOKEN_USAGE_DETAILS: '/token-usage/:orgId',
  AUDIT_TRAIL: '/audit-trail',
  HELP_DESK: '/help-desk',
} as const;

/**
 * Route path type for type safety
 
 */
export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
